import React  from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongsPage.module.scss";
import {FontIcon} from "../../components/common/FontIcon";
import TabbedNavigation from "../../components/tabbedNavigation/TabbedNavigation";
import {SongsPageNavigation} from "../../modules/songs/songs-navigation/SongsPageNavigation";
import {FilterSortDropdownMenu} from "../../modules/songs/filter-sort-dropdown-menu/FilterSortDropdownMenu";
import {
  SongsFilterMenuButtons
} from "../../components/songs/songs-page/songs-filter-menu-buttons/SongsFilterMenuButtons";
import LoadingAnimation2 from "../../components/loadingAnimation/LoadingAnimation2";
import {IfSongsPageRequestComplete} from "./modules/if-request-complete/IfSongsPageRequestComplete";
import {SongsSearchControls} from "./modules/search-controls/SongsSearchControls";
import {SongsMobileSearchControlAccess} from "./modules/mobile-search-control-access/SongsMobileSearchControlAccesss";
import {WhenDeviceTypeMobile} from "../../components/conditional/device/type/WhenDeviceTypeMobile";
import {SongsInfoModal} from "./modules/songs-info-modal/SongsInfoModal";
import {useSongsPageLogic} from "./SongsPage.logic";
import {SongResultsScrollableContent} from "./modules/results-scrollable-content/SongResultsScrollableContent";
import {useResolvedPath} from "react-router-dom";
import {MusicHomeSearchControl} from "./modules/search-controls/MusicHome/MusicHomeSearchControl";
import {
  MusicHomeMobileSearchControlAccess
} from "./modules/search-controls/MusicHome/MobileSearchControl/MusicHomeMobileSearchControlAccess";

export const SongsPage: VoidFunctionComponent = () => {
  // I don't know exactly what this is supposed to do.
  // I'll replace this with what I think the ReactRouter v6 equivalent is, and test it later.
  const url = useResolvedPath("").pathname;
  const isHomeView = ["/songs/home", "/songs"].includes(url);

  const {openModal, closeModal, isModalVisible} = useSongsPageLogic();
  return <div className={s.container}>
    <SongsInfoModal onCloseHandler={closeModal} isModalVisible={isModalVisible}/>
    <header className={s.header}>
      <h1>Songs</h1>
      <button className={s.infoIcon} onClick={openModal} aria-label={`Show Songs information`}>
        <FontIcon icon={"icon-info"}/>
      </button>
      {isHomeView ?
        <>
          <WhenDeviceTypeMobile>
            <MusicHomeMobileSearchControlAccess />
          </WhenDeviceTypeMobile>
          <MusicHomeSearchControl />
          <div className={s.viewControls}>
            <SongsPageNavigation />
          </div>
        </>:
        <>
          <WhenDeviceTypeMobile>
            <SongsMobileSearchControlAccess />
          </WhenDeviceTypeMobile>
          <SongsSearchControls />
          <div className={s.viewControls}>
            <SongsPageNavigation />
            <div className={s.viewFilters}>
              <FilterSortDropdownMenu />
              <WhenDeviceTypeMobile not>
                <SongsFilterMenuButtons />
              </WhenDeviceTypeMobile>
            </div>
          </div>
        </>
      }
    </header>
    <IfSongsPageRequestComplete fallback={LoadingAnimation2} >
      <SongResultsScrollableContent className={s.scrollableContent} />
    </IfSongsPageRequestComplete>
    <footer className={s.footer}>
      <TabbedNavigation/>
    </footer>
  </div>;
}
